import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import Common from './Common';
import Auth from './Auth';
import StoreAdminReducer from './StoreAdminReducer';
import StoreReducer from './StoreReducer';

export default history =>
  combineReducers({
    router: connectRouter(history),
    common: Common,
    auth: Auth,
    storeAdminReducer: StoreAdminReducer,
    storeReducer: StoreReducer,
  });
